module.exports = __webpack_public_path__ + "static/media/kicks.5e0b0ef6.png";